module.exports = __webpack_public_path__ + "static/wl_header_video_us-ee039112232723598d37f5dda5205f0e.mp4";